export default "__VITE_ASSET__db956edb__"